<template>
  <div v-if="foundItems !== undefined">
    <form class="a-sort" action="">
      <p class="a-sort__see">
        {{$tc('form.contractor-search.search-result', foundItems)}}
      </p>
      <button class="gui-btn gui-btn--red gui-btn--w-140 u-margin-b-24"
              @click.prevent="exportContractorsList"
              v-t="'buttons.export'">
      </button>
    </form>
    <div class="a-сard-admin">
      <div class="a-сard-admin__block" v-for="person in items">
        <div class="a-сard-admin__body">
          <div class="a-сard-admin__content-text">
            <div class="a-сard-admin__label">{{$t('labels.organization-type')}}:</div>
            <p class="a-сard-admin__text">{{$t(person.organizationType.label)}}</p>
          </div>
          <div class="a-сard-admin__content-text">
            <div class="a-сard-admin__label">{{$t('labels.organization-title')}}:</div>
            <p class="a-сard-admin__text">{{person.fullName}}</p>
          </div>
          <div class="a-сard-admin__content-text">
            <div class="a-сard-admin__label">{{$t('labels.registration-date')}}:</div>
            <date-time class="a-сard-admin__text" :value="person.dtReg" :time="false"></date-time>
          </div>
          <router-link class="gui-btn gui-btn--red gui-btn--large-red-a"
                       :to="{name: 'admin-contractor-account', params: { userId: person.id, tab: 'contractor'}}"
                       v-t="'buttons.open-profile'">
          </router-link>
        </div>
      </div>
      <button class="gui-btn gui-btn--more u-margin-24-auto" type="button" @click="fetchMoreContractors" v-if="foundItems !== items.length">{{$t('buttons.show-more')}}</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "UsersSearchResults",
    computed: {
      foundItems() { return this.$store.state.search.contractors.total },
      items() { return this.$store.state.search.contractors.items }
    },
    methods: {
      exportContractorsList() {
        this.$store.dispatch('exportContractorsList');
      },

      fetchMoreContractors() {
        this.$store.dispatch('fetchMoreContractors');
      }
    }
  }
</script>

<style scoped>

</style>
